import { render, staticRenderFns } from "./EmployeeImageUpload.vue?vue&type=template&id=1f70bbe4&scoped=true&"
import script from "./EmployeeImageUpload.vue?vue&type=script&lang=js&"
export * from "./EmployeeImageUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f70bbe4",
  null
  
)

export default component.exports